import cookie from "js-cookie";
import { useApolloClient } from "@apollo/client";
import { useMemo } from "react";
import { useProfile } from "./hooks/useProfile";

const withAuthProvider = () => {
  const apolloClient = useApolloClient();
  const { fetchMe } = useProfile();

  return useMemo(() => {
    return {
      login: async () => {
        return true;
      },
      logout: async () => {
        cookie.remove("access_token");
        localStorage.removeItem("user");
        const raStoreEntries = Object.entries(localStorage)
          .filter(([key]) => key.startsWith('RaStore.'));
        localStorage.setItem('filters', JSON.stringify(raStoreEntries));
        await apolloClient.resetStore();
        return Promise.resolve();
      },
      checkError: (error) => {
        const status = error.status;
        console.error('error', error);
        if (
          status === 401 ||
          status === 403 ||
          error.message.includes("Not Authorised!")
        ) {
          document.cookie = "";
          localStorage.removeItem("user");
          return Promise.reject({ redirectTo: "/login" });
        }
        // other error code (404, 500, etc): no need to log out
        return Promise.resolve();
      },
      checkAuth: async () => {
        await fetchMe();
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) {
          return Promise.reject({ redirectTo: "/login" });
        }

        return Promise.resolve(user);
      },
      getPermissions: () => {
        const user = JSON.parse(localStorage.getItem("user"));
        return Promise.resolve(user);
      },
      getIdentity: async () => {
        const user = JSON.parse(localStorage.getItem("user"));

        return Promise.resolve({ ...user, fullName: user.email });
      },
    };
  }, []);
};

export default withAuthProvider;
